import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { cn } from '../../utils/cn';

const navItems = [
  { path: '/', icon: 'List' },
  { path: '/calendar', icon: 'Calendar' },
  { path: '/analytics', icon: 'PieChart' },
  { path: '/settings', icon: 'Settings' },
];

export const MobileNav = () => {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 pb-safe z-40">
      <div className="flex justify-around p-3">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => cn(
              "p-3 rounded-full transition-colors",
              isActive ? "bg-teal-50 text-teal-600" : "text-slate-400 hover:text-slate-600"
            )}
          >
            <SafeIcon name={item.icon} className="w-6 h-6" />
          </NavLink>
        ))}
      </div>
    </div>
  );
};